// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__115gi","col":"styles_col__DeZxR"};